import { JSX, useEffect, useState } from "react"

import Game from "../../Model/Game"
import Status from "../../Model/Status"
import FighterInterface from "../../Model/FighterInterface"

import useGameCountdown from "../../hooks/useGameCountdown"
import useDocumentVisibility from "../../hooks/useDocumentVisibility"
import {
  fightResolver,
  gameGenerator,
  randomNumberGenerator,
} from "../../Service"
import config from "../../config.json"
import { useBodyClassName } from "../../Context/BodyClassNameContext"
import RotatePhone from "../../Component/RotatePhone"
import sleep from "../../util/sleep"

import FighterView from "../FighterView"
import MenuView from "../MenuView"

import "./game.css"

type Props = {
  daily?: boolean
  seed: string
}

export default function GameView({ daily, seed }: Props): JSX.Element {
  const [game, setGame] = useState<Game | null>(null)
  const status: Status | undefined = game?.status
  const { start, stop } = useGameCountdown(game, setGame)
  const { visible } = useDocumentVisibility()

  const { body } = useBodyClassName("game")

  useEffect((): void => {
    randomNumberGenerator.seed = seed
    setGame(gameGenerator.generate())
    // setGame(gameProvider.getGame(seed))
  }, [seed])

  useEffect((): void => {
    if (game === null) {
      return
    }

    start()
  }, [game, start])

  // Stop timer if status changes
  useEffect((): void => {
    if (status === "victory" || status === "defeat") {
      // @todo debug why it's not stopping.
      stop()
    }
  }, [status, stop])

  // Start and stop the timer on losing focus of the window.
  useEffect((): void => {
    if (game === null) {
      return
    }

    if (visible) {
      start()

      return
    }

    stop()
  }, [visible, game, start, stop])

  const handleFight = async (enemy: FighterInterface): Promise<void> => {
    if (game === null || status !== "idle" || game.enemyFighter !== undefined) {
      return
    }

    let g: Game = game.fight(enemy)
    setGame(g)
    await sleep(config.fightDuration)

    setGame(
      (g = fightResolver.resolve(enemy, g).addTime(config.timeAddedPerWin)),
    )

    await sleep(config.fightDuration)
    setGame(g.setIdle())
  }

  const handleRestart: () => void = (): void => {
    setGame(gameGenerator.generate())
  }

  if (game === null) {
    return <></>
  }

  return (
    <>
      <RotatePhone />
      <MenuView
        ref={body}
        game={game}
        daily={daily}
        onRestart={handleRestart}
      />
      {game.enemies.map(
        (enemy: FighterInterface, index: number): JSX.Element => (
          <FighterView
            key={index}
            fighter={enemy}
            onClick={async (): Promise<void> => handleFight(enemy)}
            displayValue={game.status === "defeat"}
          />
        ),
      )}
      <FighterView fighter={game.me} displayValue={game.status === "defeat"} />
      {/*<EndGameView game={game} />*/}
    </>
  )
}
